import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import { PublicLayout } from './pages/PublicLayout';
import HomePage from './pages/HomePage';
import MarketplacePage from './pages/MarketplacePage';
import SearchPage from './pages/SearchPage';
import ProductPage from './pages/ProductPage';
import StorePage from './pages/StorePage';
import BusinessPage from './pages/BusinessPage';
import ExplorePage, { DistrictPage } from './pages/ExplorePage';
import MadeInKelantanPage from './pages/MadeInKelantanPage';
import PromotionsPage, { CampaignPage } from './pages/PromotionsPage';
import PartnersPage, { PartnerDetailPage } from './pages/PartnersPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MyKelatePage from './pages/MyKelatePage';
import MerchantRegisterPage, { MerchantRegisterSuccess } from './pages/MerchantRegisterPage';
import MerchantCenter from './pages/MerchantCenter';
import AdminCenter from './pages/AdminCenter';
import DeliveryApp from './pages/DeliveryApp';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/store/:slug" element={<StorePage />} />
              <Route path="/business/:slug" element={<BusinessPage />} />
              <Route path="/explore" element={<ExplorePage />} />
              <Route path="/explore/:district" element={<DistrictPage />} />
              <Route path="/made-in-kelantan" element={<MadeInKelantanPage />} />
              <Route path="/promotions" element={<PromotionsPage />} />
              <Route path="/campaign/:slug" element={<CampaignPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/partners/:id" element={<PartnerDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route path="/account/login" element={<LoginPage />} />
              <Route path="/account/register" element={<RegisterPage />} />
              <Route path="/my-kelate/*" element={<MyKelatePage />} />
              <Route path="/merchant/register" element={<MerchantRegisterPage />} />
              <Route path="/merchant/register/success" element={<MerchantRegisterSuccess />} />
            </Route>
            <Route path="/merchant-center/*" element={<MerchantCenter />} />
            <Route path="/admin/*" element={<AdminCenter />} />
            <Route path="/delivery/*" element={<DeliveryApp />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Toaster position="top-right" richColors={false} />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
